import { render, staticRenderFns } from "./video.vue?vue&type=template&id=ffa78ca2&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=ffa78ca2&prod&lang=less&scoped=true&"
import style1 from "./video.vue?vue&type=style&index=1&id=ffa78ca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa78ca2",
  null
  
)

export default component.exports